import { useContext } from 'react';
import { AppModal, IconButton } from '../';
import { AppContext } from '../../providers/AppContext';
import { StyledDesktopOnlyModal } from './DesktopOnlyModal.styled';

const DesktopOnlyTitle = () => {
  return (
    <div className='desktop-only-modal-title-holder'>
      <div className='desktop-only-modal-title-stub-short' />
      <div className='desktop-only-modal-title'>Its Desktop only Odyssey :[</div>
      <div className='desktop-only-modal-title-stub-long'>
        <img src='/assets/controller.svg' />
      </div>
    </div>
  );
};

const DesktopOnlyModal = () => {
  const onClick = () => {
    setShowDesktopOnly(false);
  };

  const { setShowDesktopOnly } = useContext(AppContext);

  return (
    <AppModal dark={true}>
      <StyledDesktopOnlyModal>
        <DesktopOnlyTitle />
        <div className='desktop-only-modal'>
        <div className='desktop-only-modal-content'>
	  <div className='desktop-only-modal-message'>Access exclusively through the desktop dimension! We are waiting for you!</div>
          <IconButton onClick={onClick} animated={false}>
            <div className='connect-wallet-button-content'>
              <div>On My Way to Desktop</div>
              <img style={{paddingBottom: '6px'}} src='/assets/desktop.svg'/>
            </div>
          </IconButton>
        </div>
        </div>
      </StyledDesktopOnlyModal>
    </AppModal>
  );
};

export default DesktopOnlyModal;
